import {
    AfterContentInit,
    Component,
    ContentChildren,
    EventEmitter,
    InjectionToken,
    Output,
    QueryList,
    ViewChild
} from "@angular/core";
import {AbstractControl, FormControl, NgForm, NgModel} from "@angular/forms";
import {ValidationMessage} from "@fedelta-pos/data-client";
import {MessageDetails, MessageLevel} from "../../notification/message/message";
import {NotificationService} from "../../notification/notification.service";

export const FORM_CONTROL: InjectionToken<FormComponent> = new InjectionToken("FORM_CONTROL");

export abstract class AbstractModelContainer {
    public abstract getModels(): QueryList<NgModel>;
}

@Component({
    selector: "woa-form",
    templateUrl: "./form.component.html",
    providers: [{provide: FORM_CONTROL, useExisting: FormComponent, multi: true}]
})
export class FormComponent implements AfterContentInit {
    @Output() onSubmit: EventEmitter<any> = new EventEmitter();

    @ViewChild("ngForm") private ngForm: NgForm;
    @ContentChildren(NgModel, {descendants: true}) private models: QueryList<NgModel>;
    @ContentChildren(AbstractModelContainer, {descendants: true}) private modelContainers: QueryList<AbstractModelContainer>;

    constructor(private notificationService: NotificationService) {
    }

    ngAfterContentInit(): void {
        this.findContentControls();
        this.models.changes.subscribe(() => this.findContentControls());
        this.modelContainers.changes.subscribe(() => this.findContentControls());
    }

    private findContentControls(): void {
        Object.keys(this.ngForm.controls).forEach((key: string) => {
            this.ngForm.form.removeControl(key);
        });
        this.models.forEach((model: NgModel) => this.ngForm.addControl(model));
        this.modelContainers.forEach((modelContainer: AbstractModelContainer) => {
            if (modelContainer.getModels()) {
                modelContainer.getModels().forEach((model) => this.ngForm.addControl(model));
            }
        });
    }

    public submit(event?: any): void {
        this.ngForm.onSubmit(event);
    }

    public get submitted(): boolean {
        return this.ngForm.submitted;
    }

    public get valid(): boolean {
        return this.ngForm.valid;
    }

    public markAsUnsubmitted(): void {
        this.ngForm["_submitted"] = false;
    }

    public reset(): void {
        this.markAsUnsubmitted();
        for (let controlName in this.ngForm.controls) {
            this.ngForm.controls[controlName]["_dirty"] = false;
        }
    }

    public hasError(field: FormControl | AbstractControl, type?: string): boolean {
        return field && (this.submitted || field["_dirty"]) && field.errors && (!type || field.errors[type]);
    }

    public applyServerValidationMessages(validationMessages: ValidationMessage[]) {
        validationMessages.forEach((validationMessage: ValidationMessage) => {
            if (validationMessage.fieldPath && this.ngForm.controls[validationMessage.fieldPath]) {
                const serverErrors = this.ngForm.controls[validationMessage.fieldPath].errors && this.ngForm.controls[validationMessage.fieldPath].errors.server;
                if (serverErrors) {
                    serverErrors.validationMessages.push(validationMessage);
                } else {
                    this.ngForm.controls[validationMessage.fieldPath].setErrors({
                        server: {"validationMessages": [validationMessage]}
                    });
                }
            } else {
                this.notificationService.displayFooterMessage(new MessageDetails(MessageLevel.ERROR, validationMessage.messageKey, validationMessage.messageParams));
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/inputs/form/form.component.ts